import { onBeforeUpdate, ref } from 'vue';

import type { Ref } from 'vue';

export interface IUseRefs<T extends {}> {
  refs: Ref<(T | undefined)[]>;
  updateRef: (value: any, index: number) => void;
}

export function useRefs<T extends {}>(): IUseRefs<T> {
  const refs = ref<(T | undefined)[]>([]) as Ref<(T | undefined)[]>;

  onBeforeUpdate(() => (refs.value = []));

  function updateRef(value: any, index: number) {
    refs.value[index] = value;
  }

  return { refs, updateRef };
}
